import React from 'react';

/**
 * Content for the Step 4 evidence request screen
 * (/supporting-evidence/medical-records) per the finalized 2026 design
 * (docs/firehorse_step4/step4_flow0.png, #151946).
 */
export const evidenceRequestQuestion = {
  label:
    'Are there medical records related to your claim that you’d like us to review on your behalf from VA or other healthcare providers?',
  labels: {
    Y: 'Yes',
    N: 'No',
  },
  descriptions: {
    Y: 'I’ll upload my medical records or will give VA permission to request them from VA health facilities or other healthcare providers',
    N: 'I don’t want to provide medical records right now',
  },
};

export const evidenceRequestNote = (
  <p>
    <strong>Note:</strong> We can locate, access, and review medical records
    from VA facilities right away when you submit your claim. But we need your
    permission to request access to your records from other healthcare
    facilities on your behalf.
  </p>
);
